import { LedgerEntry } from '@dataTypes/billing.types'
import axios from '../axiosConfig'
import { getEnv } from '@utils/env'
import { logger } from '@utils/safeLogger'

const BUSINESS_LAYER_API = getEnv('REACT_APP_BUSINESS_LAYER_BILLING', '')

interface ApiResponse<T> {
  statusCode: number
  message: string
  data: T
}

export type LedgerQueryFilters = {
  patient_id?: string
  clinic_id?: string
  provider_id?: string | string[]
  search?: string
  limit?: number
  offset?: number
  sort?: string
}

export type GetLedgerEntriesResponse = ApiResponse<{
  entries?: LedgerEntry[]
  count?: number
}>

export const getLedgerEntries = async (
  filters?: LedgerQueryFilters,
): Promise<GetLedgerEntriesResponse> => {
  try {
    const response = await axios.get<GetLedgerEntriesResponse>(
      `${BUSINESS_LAYER_API}/api/v1/ledger`,
      {
        params: filters,
      },
    )

    return response.data
  } catch (e: unknown) {
    logger.error('Error in getLedgerEntries:', e)
    throw e
  }
}

export type ExportLedgerCsvFilters = {
  patient_id?: string
  clinic_id?: string | string[]
  search?: string
  sort?: string
}

export const exportLedgerEntriesCsv = async (
  filters?: ExportLedgerCsvFilters,
): Promise<Blob> => {
  const response = await axios.get<Blob>(
    `${BUSINESS_LAYER_API}/api/v1/ledger/export/csv`,
    { params: filters ?? {}, responseType: 'blob' },
  )
  return response.data
}
